<script type="text/ecmascript-6">
    import DesignerQuestionHardwareLock from "../DesignerQuestionHardwareLock.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareLock,
            TileQuestion
        ],
        computed: {
            thumbURL(){
                return '/thumb/hardware/';
            },
        },
        props: {
          component_id: {
            required: false,
          },
        },
    }
</script>
